import * as React from 'react';
import { classes, style } from 'typestyle';
const ButtonContainer = ({ children, className = '' }) => {
    return React.createElement("div", { className: classes('btn-container', buttonContainerStyle, className) }, children);
};
export default ButtonContainer;
const margin = 8;
const buttonContainerStyle = style({
    width: `100%`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: `${12 - margin}px 12px ${4 + margin}px ${12 - margin}px`,
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    $nest: {
        '& > button': {
            flexGrow: 1,
            marginLeft: margin,
            marginTop: margin,
        },
        '& > .ta-duplex-btn': {
            flexGrow: 0,
            paddingLeft: margin,
            paddingRight: margin,
        },
    },
});
//# sourceMappingURL=ButtonContainer.js.map